import { render } from "./ClientPerformanceChart.vue?vue&type=template&id=5f9517e0&scoped=true"
import script from "./ClientPerformanceChart.vue?vue&type=script&lang=js"
export * from "./ClientPerformanceChart.vue?vue&type=script&lang=js"

import "./ClientPerformanceChart.vue?vue&type=style&index=0&id=5f9517e0&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-5f9517e0"

export default script